define('ordersDetailMessagesBodyView',[
  'app',
  'module',
  'backbone',
  'marionette',
  'underscore',
  'ordersDetailMessagesBodyMessageView',
  'modalsConfirmationView',
  'entities/command_tickets'
], function (
  App,
  Module,
  Backbone,
  Marionette,
  _,
  MessageView,
  ConfirmationView
) {
  'use strict';

  Module.exports = Marionette.CollectionView.extend({
    className: 'body-view',
    childView: MessageView,

    childEvents: {
      'delete': 'onDelete'
    },  

    initialize: function() {
      this.collection = new Backbone.Collection();   
      
      this.listenTo(this.model.get('order'), 'change', _.bind(function() {
        this.fetch();
      }, this));
    },

    onRender: function() {
      this.fetch(); 
    },    

    fetch: function() {
      App.request('commandtickets:purchaseorder', this.model.get('poi'), true).done(_.bind(function(response) {
        if(response.responseJSON) {
          this.options.parentView.ticket = response.responseJSON[0];

          _.each(response.responseJSON[0].messages, function(message) {       
            var model = App.request('customer:message:model', {
              secId: message.secId,
              msgDate: message.date,
              userpid: message.userPid,
              content: message.content,
              attachments: message.attachements || []
            });      
            
            this.collection.add(model);  
          }, this);  

          this.triggerMethod('scrooltop');
        }            
      }, this));
    },

    onDelete: function(childView) {    
      ConfirmationView.prototype.open({
        text: _.i18n('warning.deleteMessage'),
        onConfirm: _.bind(function () {
          App.request('commandtickets:delete-message', childView.model.get('secId')).done(_.bind(function () {           
            this.collection.remove(childView.model);
            this.triggerMethod('scrooltop');
          }, this));
        }, this)
      });
    }
  });
});
